import {atom, useAtomValue, useSetAtom} from 'jotai';

const CSRFMiddlewareTokenAtom = atom(global.CSRFMiddlewareToken || null);

export const useCSRFMiddlewareToken = () => useAtomValue(CSRFMiddlewareTokenAtom);

export const useUpdateCSRFMiddlewareToken = () => useSetAtom(CSRFMiddlewareTokenAtom);
